"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@mui/styles");
const useStyles = exports.useStyles = (0, _styles.makeStyles)(MUITheme => ({
  footerDivider: {
    backgroundColor: MUITheme.palette.border.grey,
    marginBottom: "20px"
  },
  copyrightText: {
    color: MUITheme.palette.text.lightGrey,
    opacity: "70%",
    fontSize: "14px",
    textAlign: "center",
    lineHeight: "21px"
  }
}));